import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, shareReplay, catchError } from 'rxjs/operators';
import { GameSearchQueryDTO } from './game-search.model';

@Injectable({ providedIn: 'root' })
export class GameSearchService {
  private readonly searchUrl = '/search/api/v1/games';
  readonly pageSize = 20;

  private readonly lookupCache = new Map<string, Observable<any[]>>();

  constructor(private http: HttpClient) {}

  search(query: string, offset: number): Observable<GameSearchQueryDTO> {
    const params = new HttpParams()
      .set('query', query)
      .set('offset', String(offset))
      .set('country-code', 'GB')
      .set('age-verified', 'true')
      .set('build-id', '26');
    return this.http.get<GameSearchQueryDTO>(this.searchUrl, { params });
  }

  /**
   * Resolve a full admin game-instance row (casinolookup / casinofreespinlookup)
   * so save payload keeps gameId, cohortId, logoUrl, status, etc.
   */
  resolveGameInstance(selectUrl: string, searchId: number): Observable<any | null> {
    if (!selectUrl || searchId == null) {
      return of(null);
    }

    return this.getLookupList(selectUrl).pipe(
      map((list) => list.find((game) => game?.id === searchId || game?.gameId === searchId) || null),
      catchError(() => of(null))
    );
  }

  private getLookupList(selectUrl: string): Observable<any[]> {
    if (!this.lookupCache.has(selectUrl)) {
      const request$ = this.http.get<any>(selectUrl).pipe(
        map((resp) => {
          if (Array.isArray(resp)) {
            return resp;
          }
          if (resp?.content && Array.isArray(resp.content)) {
            return resp.content;
          }
          return [];
        }),
        shareReplay(1),
        catchError(() => of([]))
      );
      this.lookupCache.set(selectUrl, request$);
    }
    return this.lookupCache.get(selectUrl);
  }
}
